import { show, hide } from "../Helpers/helpers";
import { _addEventListener } from "../Helpers/eventHelper";
import Swiper from "swiper";
import { Navigation, Pagination, Thumbs } from "swiper/modules";

export default class {
    constructor(productGalleryAttr) {
        this.productGalleryEl = document?.querySelector(productGalleryAttr);
        if (this.productGalleryEl) {
            this.sliderInitialized = false;
            this.isOpen = false;
            this.swiper = null;
            this.swiperThumbs = null;
            this.initializedGalleries = {};
            this.init();
        }
    }

    init() {
        this.showMoreImagesHandler();
        this.initSliders();
        window.addEventListener("resize", this.initSliders());
    }

    getProductGallery() {
        return this.productGalleryEl;
    }

    showMoreImagesHandler() {
        const galleryShowMoreBtn = this.productGalleryEl.querySelector("[data-product-gallery-show-more]");
        _addEventListener(galleryShowMoreBtn, "click", (event) => {
            this.showOrHideMoreImages(event);
        });
    }

    showOrHideMoreImages(event) {
        event?.preventDefault();
        const galleryImages = this.productGalleryEl.querySelectorAll("[data-product-gallery-desktop-item]");
        const label = this.productGalleryEl.querySelector("[data-product-gallery-show-more-label]");
        const icon = this.productGalleryEl.querySelector("[data-product-gallery-show-more-icon]");
        if (this.isOpen) {
            this.hideMoreImages(galleryImages, label, icon);
        } else {
            this.showMoreImages(galleryImages, label, icon);
        }
    }

    showMoreImages(galleryImages, label, icon) {
        galleryImages.forEach((galleryImage) => {
            if (galleryImage.classList.contains("medium-up:tw-hidden")) {
                galleryImage.classList.remove("medium-up:tw-hidden");
            }
        });
        label.innerText = "Show less media";
        icon.style = "transform: rotate(-90deg)";
        this.isOpen = true;
    }

    hideMoreImages(galleryImages, label, icon) {
        galleryImages.forEach((galleryImage) => {
            if (!galleryImage.classList.contains("medium-up:tw-hidden")) {
                galleryImage.classList.add("medium-up:tw-hidden");
            }
        });
        label.innerText = "Show more media";
        label.scrollIntoView({ behavior: "smooth", block: "center" });
        icon.style = "transform: rotate(90deg)";
        this.isOpen = false;
    }

    setVisibilityForDesktop(gallery) {
        const galleryImages = gallery.querySelectorAll("[data-featured-media-id]");
        galleryImages.forEach((galleryImage, index) => {
            const isHidden = index > 4;
            const toggleAttribute = (condition) => {
                if (condition) {
                    galleryImage.setAttribute("data-product-gallery-desktop-item", "");
                } else {
                    galleryImage.removeAttribute("data-product-gallery-desktop-item");
                }
            };
            if (this.isOpen) {
                galleryImage.classList.toggle("medium-up:tw-hidden", false);
                toggleAttribute(isHidden);
            } else {
                galleryImage.classList.toggle("medium-up:tw-hidden", isHidden);
                toggleAttribute(isHidden);
            }
        });

        this.updateGalleryCounter(galleryImages);
    }

    updateGalleryCounter(galleryImages) {
        const showMoreBtnCounter = this.productGalleryEl.querySelector("[data-product-gallery-show-more-counter]");

        if (!showMoreBtnCounter) return;

        if (galleryImages.length > 5) {
            showMoreBtnCounter.innerText = galleryImages.length - 5;
            showMoreBtnCounter.parentNode.classList.add("medium-up:tw-flex");
        } else {
            showMoreBtnCounter.parentNode.classList.remove("medium-up:tw-flex");
        }
    }

    initSliders() {
        if (window.innerWidth <= 768) {
            if (!this.sliderInitialized) {
                this.sliderInitialized = true;
                this.initThumbsSwiper();
                this.initMainSwiper();
            }
        } else {
            this.sliderInitialized = false;
        }
    }

    initThumbsSwiper() {
        this.swiperThumbs = new Swiper("[data-pdp-gallery-thumbs]", {
            modules: [Navigation, Pagination],
            direction: "horizontal",
            slidesPerView: 3.5,
            loop: false,
            spaceBetween: 1,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
        });
    }

    initMainSwiper() {
        this.swiper = new Swiper("[data-pdp-gallery-slider]", {
            modules: [Navigation, Pagination, Thumbs],
            direction: "horizontal",
            slidesPerView: 1,
            centeredSlides: true,
            loop: false,
            spaceBetween: 0,
            thumbs: {
                swiper: this.swiperThumbs,
            },
        });
    }
}
